export const is_admin = !!new URLSearchParams(window.location.search).get("admin");
